import { cn } from 'cn';
import { PERSONA_LABEL, actingAsDisplay, personaHome, useSession } from '@/app/session';
import { Avatar, AvatarFallback } from '@/components/ui/avatar';
import { initials } from '@/lib/format';
import { WIDTH_CLASS, useShell } from './context';
import { ModeChips } from './ModeChips';
import { PersonaNav } from './PersonaNav';
import { SearchTrigger } from './MatterSearch';
import { UserMenu } from './UserMenu';
import { Wordmark } from './Wordmark';

/**
 * 52 px desktop, 56 px phone, ink ground, cream text. Desktop: wordmark,
 * persona nav, search trigger, mode chips, user menu. Phone: wordmark,
 * persona chip, avatar (opens the menu sheet); nav and search move to the
 * bottom bar. Sticky: the shell's chrome budget (docs/ux/shell.md) keeps the
 * bar on screen, and the table head, the compact strip and the workspace's
 * attention bar all take their offset from it.
 */
export function TopBar() {
  const { me } = useSession();
  const { width, setMenuOpen } = useShell();
  const acting = actingAsDisplay(me?.actingAsName, me?.actingAs ?? null);
  return (
    <header role="banner" data-on-ink data-slot="top-bar" className="sticky top-0 z-40 bg-beam-ink text-beam-cream">
      <div className={cn('mx-auto flex h-14 w-full items-center gap-6 px-4 md:h-[52px] md:px-6', WIDTH_CLASS[width])}>
        <Wordmark to={personaHome(me?.persona)} />
        <PersonaNav className="hidden md:flex" />
        <div className="ml-auto flex items-center gap-3">
          <SearchTrigger className="hidden md:flex" />
          <ModeChips className="hidden md:flex" />
          <div className="hidden md:block">
            <UserMenu />
          </div>
          {me ? (
            <button
              type="button"
              onClick={() => setMenuOpen(true)}
              aria-label="Account and menu"
              className="flex h-11 items-center gap-2 rounded-md px-1 md:hidden"
            >
              <span className="rounded-full border border-white/25 px-2 py-0.5 text-[11px] font-medium text-beam-on-ink-muted">
                {acting ? `Acting as ${acting}` : PERSONA_LABEL[me.persona]}
              </span>
              <Avatar size="sm">
                <AvatarFallback className="bg-beam-harbour text-beam-ink">{initials(me.name)}</AvatarFallback>
              </Avatar>
            </button>
          ) : null}
        </div>
      </div>
    </header>
  );
}
